import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static keyDownHandler(e) {
    if (e.target.tagName === 'TEXTAREA') {
      return;
    }

    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  keyDownHandler(e) {
    this.constructor.keyDownHandler(e);
  }
}
